const state = {
  count: 1,
  showMenu: true,
  status: false,
  step: 1,
  productType: 0,
  questionType: 0,
  desc: '',
  questionImgUrl: '',
  productName: '',
  tag: 1,
  email: '',
  type: '贝壳',
  sign: false,
  questionName: '',
  cityCode: '',
  cityName: ''
};
const mutations = {
  AMOUNT_COUNT: (state, num) => {
    state.count += num;
  },
  CHANGE_MENU: (state) => {
    state.showMenu = !state.showMenu;
  },
  CHANGE_STATUS: (state, status) => {
    state.status = status;
  },
  CHANGE_STEP: (state, step) => {
    state.step = step;
  },
  CHANGE_TYPES: (state, type) => {
    state.productType = type;
  },
  CHANGE_QUESTION: (state, question) => {
    state.questionType = question;
  },
  CHANGE_DESC: (state, desc) => {
    state.desc = desc;
  },
  CHANGE_URL: (state, url) => {
    state.questionImgUrl = url;
  },
  CHANGE_NAME: (state, productName) => {
    state.productName = productName;
  },
  CHANGE_TAG: (state, tag) => {
    state.tag = tag;
  },
  CHANGE_EMAIL: (state, email) => {
    state.email = email;
  },
  CHANGE_TYPE: (state, type) => {
    state.type = type;
  },
  CHANGE_SIGN: (state, sign) => {
    state.sign = sign;
  },
  CHANGE_QUESTIONNAME: (state, questionName) => {
    state.questionName = questionName;
  },
  CHANGE_CITYCODE: (state, cityCode) => {
    state.cityCode = cityCode;
  },
  CHANGE_CITYNAME: (state, cityName) => {
    state.cityName = cityName;
  }
};
const actions = {
  addCount({ commit }, num) {
    commit('AMOUNT_COUNT', num);
  },
  changeMenu({ commit }) {
    commit('CHANGE_MENU');
  },
  changeStatus({ commit }) {
    commit('CHANGE_STATUS');
  },
  resetVuex({ commit }) {
    // commit("CHANGE_STATUS", false);
    commit("CHANGE_STEP", 1);
    commit("CHANGE_TYPES", 0);
    commit("CHANGE_QUESTION", 0);
    commit("CHANGE_DESC", '');
    commit("CHANGE_URL", '');
    commit("CHANGE_NAME", '');
    commit("CHANGE_TAG", 1);
    commit("CHANGE_TYPE", '贝壳');
    commit("CHANGE_EMAIL", '');
    commit("CHANGE_SIGN", false);
    commit("CHANGE_QUESTIONNAME", '');
    commit("CHANGE_CITYCODE", '');
    commit("CHANGE_CITYNAME", '');
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
